"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/XKFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_252)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_252`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6.00024 0H30.0001V24.0007H-6.00024V0Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.51928 2.99738L10.0783 4.13013L11.3277 4.31154L10.4235 5.19326L10.6373 6.43781L9.51928 5.84999L8.4013 6.43781L8.61435 5.19326L7.71012 4.31154L8.96029 4.13013L9.51928 2.99738ZM14.4806 2.99316L15.0396 4.12521L16.2897 4.30732L15.3855 5.18834L15.5986 6.43359L14.4806 5.84577L13.3626 6.43359L13.5763 5.18834L12.6721 4.30732L13.9216 4.12521L14.4806 2.99316ZM18.8456 3.79192L19.4046 4.92467L20.6541 5.10608L19.7498 5.9878L19.9636 7.23235L18.8456 6.64523L17.7276 7.23235L17.9414 5.9878L17.0365 5.10608L18.2866 4.92467L18.8456 3.79192ZM23.2761 5.07865L23.835 6.2114L25.0845 6.39351L24.1803 7.27453L24.394 8.51978L23.2761 7.93196L22.1581 8.51978L22.3711 7.27453L21.4669 6.39351L22.7171 6.2114L23.2761 5.07865ZM5.15423 3.79192L5.71322 4.92467L6.96339 5.10608L6.05846 5.9878L6.27221 7.23235L5.15423 6.64523L4.03625 7.23235L4.25001 5.9878L3.34578 5.10608L4.59524 4.92467L5.15423 3.79192ZM0.723799 5.07865L1.28279 6.2114L2.53296 6.39351L1.62873 7.27453L1.84178 8.51978L0.723799 7.93196L-0.39418 8.51978L-0.180429 7.27453L-1.08466 6.39351L0.164809 6.2114L0.723799 5.07865Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.29498 18.2343L7.38106 17.2774L5.46713 13.4502H7.38106L9.29498 11.5363L10.2519 9.62237L12.1659 8.66541L13.1228 9.62237L15.0368 10.5793V11.5363L15.9937 12.4933L18.8646 14.4072L17.9062 17.2781L15.0354 20.149L14.0784 18.235L11.2075 20.149V22.0629L10.2505 21.1059L9.29498 18.2343Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_252`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as XKFlag };
